import * as types from './types';
import { has } from 'lodash';

const INITIAL_STATE = {
  fetching: true,
  loading: false,
  error: null,
  configuration: {},
  grades: [],
  sites: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.POWERSCHOOL_INTEGRATION_SAVE_CONFIGURATION:
      return { ...state };
    case types.POWERSCHOOL_INTEGRATION_FETCHING:
      return { ...state, fetching: payload };
    case types.POWERSCHOOL_INTEGRATION_LOADING:
      return { ...state, loading: payload };
    case types.POWERSCHOOL_INTEGRATION_ERROR:
      if (
        has(payload, 'response.data.Errors') &&
        payload.response.data.Errors.length > 0
      ) {
        const error = payload.response.data.Errors[0];
        return {
          ...state,
          error,
        };
      } else {
        return {
          ...state,
          error: {
            Title: 'Error',
            Message:
              'An error occurred while savings your PowerSchool settings. Please try again',
          },
        };
      }
    case types.POWERSCHOOL_INTEGRATION_CLEAR_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.POWERSCHOOL_INTEGRATION_SET_CONFIGURATION:
      delete payload.CloneObject;

      return {
        ...state,
        configuration: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/state/powerschool/reducer.js